import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Store entities
import { getCompanyState } from '../../../../../../store/company/company.selectors';

// Styles
import './preview-block.scss';

// Models
import { TWidgetType } from '../../../../../../types/widget.types';
import { IWidgetInfo } from '../../../../../../interfaces/widget-settings.interfaces';

export type TPreviewBlockRef = {
  reloadWidget: () => void;
};

type TPreviewBlockProps = {
  type: TWidgetType;
  widget_settings: IWidgetInfo;
};

export const PreviewBlock = forwardRef<TPreviewBlockRef, TPreviewBlockProps>(
  ({ type, widget_settings }: TPreviewBlockProps, ref
  ) => {

    const [frameSrc, setFrameSrc] = useState<string | null>(null);
    const [frameKey, setFrameKey] = useState<string>(Math.random().toString(16).slice(2));

    const { company } = useSelector(getCompanyState);

    const mountWidget = (): void => {
      setFrameSrc(`${ process.env.REACT_APP_USER_APP_URL?.replace(/(customer-web-app|my)/gi, type) }/${ company?.url_code }?type=${ type }&hash=${ company?.url_code }`);
      // setFrameSrc(`http://localhost:3001/${ company?.url_code }?type=${ type }&hash=${ company?.url_code }`);
    }

    useImperativeHandle(ref, () => ({
      reloadWidget(): void {
        setFrameKey(Math.random().toString(16).slice(2));
      }
    }));

    useEffect(() => {
      if (!company?.url_code) return;
      mountWidget();
    }, [company?.url_code]);

    useEffect(() => {
      if (!widget_settings) return;
      setFrameKey(Math.random().toString(16).slice(2));
    }, [widget_settings]);

    return (
      <div className="preview-block">
        <div className="preview-block--header">
          <div className="header-title">
            Preview
          </div>
        </div>
        <div className="preview-block--body">
          { type === 'popup' && <>
            <div className="body-item ppt-widget-button">
              <div className="ppt-widget-button--title"
                   hidden={ !widget_settings.widget_show_text || !widget_settings.widget_text_message }>
                { widget_settings.widget_text_message }
                <div className="title-close">
                  <CustomIcon size={ 'size-md' } skipSize={ true } name={ EIconName.Close }/>
                </div>
              </div>
              <div className="ppt-widget-button--actions"
                   style={ { backgroundColor: widget_settings.theme_settings.elemental_header_color } }>
                <CustomIcon size={ 'size-xll' } skipSize={ true } name={ EIconName.ChatIcon }/>
              </div>
            </div>
          </> }
          <div className={ `body-item widget-content-${ type }` }>
            {
              frameSrc &&
              <div className="widget-root--body">
                <iframe src={ frameSrc } key={ frameKey }
                        allow="camera;microphone;fullscreen;payment"
                        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                />
              </div>
            }
          </div>
        </div>
      </div>
    );
  })
